import React, { Component } from 'react'
import { StripeProvider } from 'react-stripe-elements'

const withStripeProvider = (BaseComponent) =>
  class WithStripeProviderWrapper extends Component {
    render() {
      return (
        <StripeProvider apiKey={process.env.REACT_APP_STRIPE_PUBLIC_KEY}>
          <BaseComponent {...this.props} />
        </StripeProvider>
      )
    }
  }

export default withStripeProvider



// WEBPACK FOOTER //
// ./src/components/hocs/withStripeProvider.js